// extracted by mini-css-extract-plugin
module.exports =  {"logo":"logo--6Zu+HtDgxn4Q9yGRs6oTpg=="};